"use strict";

var EventEmitter = require("events").EventEmitter;
var LoggerInstance = require("js-logger").get("AccountStore");

var Dispatcher = require("./Dispatcher");
var AccountConstants = require("./AccountConstants");

var AbstractStore = require("../stores/AbstractStore");

var Constants = require("../designer/Constants");

var CHANGE_EVENT = "change";

var state = {
	account: {},
	accountCodes: [],
	availableMediaValues: [],
	companyCode: null,
	formIsInputDisabledByForm: {},
	isAutoAddStateAndPostalCodes: false,
	isDesignMode: false,
	otherAddresses: [],
	previousMediaRequest: null,
	selectedCountryByForm: {},
	selectedEmailTypeByForm: {},
	selectedOrganizationTypeForm: {},
	selectedPhoneTypeByForm: {},
	selectedStateByForm: {},
	selectedTitleByForm: {},
	selectedMediaOutlet: null,
	wizardAccountDisplayMessages: {},
	wizardAccountTitles: {},
	wizardAddressStandardization: {},
	wizardChildCommunicationsWriteDisplayMessages: {},
	wizardCompanyEftErrorMessages: {},
	wizardCompanyErrorMessages: {},
	wizardCountryList: {},
	wizardCountryStateList: {},
	wizardCreditCardDisplayMessages: {},
	wizardDateFormat: {},
	wizardDefaultAddressTypes: {},
	wizardDefaultEmailTypes: {},
	wizardDefaultPhoneTypes: {},
	wizardEventSearch: {},
	wizardLoginDisplayMessages: {},
	wizardMySponsorshipsDisplayMessages: {},
	wizardMyRecurringDisplayMessages: {},
	wizardOrganizationContactTypes: {},
	wizardOrganizationTypes: {},
	wizardOtherAddressesDisplayMessages: {},
	wizardSavedPaymentsDisplayMessages: {},
	wizardShoppingCartDisplayMessages: {},
	wizardSmartyStreetsApiKey: {},
	wizardSponsorshipDefaults: {},
	wizardYearEndGivingStatementDisplayMessages: {}
};

var AccountStore = class extends AbstractStore {
	//Specific event for address changes
	addSpecificListener(eventName, callback) {
		this.on(eventName, callback);
	}

	removeSpecificListener(eventName, callback) {
		this.removeListener(eventName, callback);
	}

	emitSpecificEvent(eventName) {
		this.emit(eventName);
	}

	getState() {
		return state;
	}

	// This would normally be done by registering the following items in Dispatcher.  However, using the Dispatcher to complete these actions
	// caused an issue where we would attempt to dispatch in the middle of another dispatch.
	setStateByType(stateType, value) {
		switch (stateType) {
			case AccountConstants.SET_MEDIA_OUTLET:
				state.selectedMediaOutlet = value;

				AccountStore.emitSpecificEvent(AccountConstants.SET_MEDIA_OUTLET);
				break;

			case AccountConstants.SET_PREVIOUS_MEDIA_REQUEST:
				state.previousMediaRequest = value;
				break;

			case AccountConstants.SET_AVAILABLE_MEDIA_VALUES:
				state.availableMediaValues = value;

				AccountStore.emitSpecificEvent(AccountConstants.SET_AVAILABLE_MEDIA_VALUES);
				break;

			default:
				// no op
				LoggerInstance.debug(`Attempted set for undefined state type in account store. ${stateType}`);
		}

		AccountStore.emitChange();
	}

	get(key) {
		return state[key];
	}

	getDefaultCountry() {
		var wizardCountryList = state.wizardCountryList;
		if (wizardCountryList && wizardCountryList.defaultCountry) {
			return wizardCountryList.defaultCountry;
		}

		return null;
	}

	getUnknownCountry() {
		var wizardCountryList = state.wizardCountryList;
		if (wizardCountryList && wizardCountryList.defaultNoAddressCountry) {
			return wizardCountryList.defaultNoAddressCountry;
		}

		return null;
	}

	getSelectedCountry(formParentId) {
		if (state.selectedCountryByForm && formParentId) {
			return state.selectedCountryByForm[formParentId] || null;
		} else {
			LoggerInstance.debug("The formParentId argument was not passed into AccountStore.getSelectedCountry()");
		}

		return null;
	}

	getSelectedEmailType(formParentId) {
		if (state.selectedEmailTypeByForm && formParentId) {
			return state.selectedEmailTypeByForm[formParentId] || null;
		}
		LoggerInstance.debug("The formParentId argument was not passed into AccountStore.getSelectedEmailType()");
		return null;
	}

	getSelectedOrganizationType(formParentId) {
		if (state.selectedOrganizationTypeForm && formParentId) {
			return state.selectedOrganizationTypeForm[formParentId] || null;
		} else {
			LoggerInstance.debug("The formParentId argument was not passed into AccountStore.getSelectedOrganizationType()");
		}
	}

	getSelectedPhoneType(formParentId) {
		if (state.selectedPhoneTypeByForm && formParentId) {
			return state.selectedPhoneTypeByForm[formParentId] || null;
		}
		LoggerInstance.debug("The formParentId argument was not passed into AccountStore.getSelectedPhoneType()");
		return null;
	}

	getSelectedState(formParentId) {
		if (state.selectedStateByForm && formParentId) {
			return state.selectedStateByForm[formParentId] || null;
		} else {
			LoggerInstance.debug("The formParentId argument was not passed into AccountStore.getSelectedState()");
		}

		return null;
	}

	getSelectedTitle(formParentId) {
		if (state.selectedTitleByForm && formParentId) {
			return state.selectedTitleByForm[formParentId] || null;
		} else {
			LoggerInstance.debug("The formParentId argument was not passed into AccountStore.getSelectedTitle()");
		}
	}

	getIsFormInputDisabled(formParentId) {
		if (state.formIsInputDisabledByForm && formParentId) {
			return state.formIsInputDisabledByForm[formParentId] || null;
		} else {
			LoggerInstance.debug("The formParentId argument was not passed into AccountStore.getIsFormInputDisabled()");
		}

		return null;
	}
};
AccountStore = new AccountStore();

AccountStore.dispatchToken = Dispatcher.register(function (action) {
	switch (action.actionType) {
		case Constants.ACCOUNT_INITIALIZE:
			state.account = action.account;
			state.accountCodes = action.accountCodes;
			state.companyCode = action.companyCode;
			state.isDesignMode = action.isDesignMode;
			state.otherAddresses = action.otherAddresses;
			state.domainWhitelist = action.domainWhitelist;
			state.wizardAccountDisplayMessages = action.wizardAccountDisplayMessages;
			state.wizardAccountTitles = action.wizardAccountTitles;
			state.wizardAddressStandardization = action.wizardAddressStandardization;
			state.wizardChildCommunicationsWriteDisplayMessages = action.wizardChildCommunicationsWriteDisplayMessages;
			state.wizardCountryList = action.wizardCountryList;
			state.wizardCountryStateList = action.wizardCountryStateList;
			state.wizardCompanyEftErrorMessages = action.wizardCompanyEftErrorMessages;
			state.wizardCompanyErrorMessages = action.wizardCompanyErrorMessages;
			state.wizardCreditCardDisplayMessages = action.wizardCreditCardDisplayMessages;
			state.wizardDateFormat = action.wizardDateFormat;
			state.wizardDefaultAddressTypes = action.wizardDefaultAddressTypes;
			state.wizardDefaultEmailTypes = action.wizardDefaultEmailTypes;
			state.wizardDefaultPhoneTypes = action.wizardDefaultPhoneTypes;
			state.wizardEventSearch = action.wizardEventSearch;
			state.wizardLoginDisplayMessages = action.wizardLoginDisplayMessages;
			state.wizardMyPledgesDisplayMessages = action.wizardMyPledgesDisplayMessages;
			state.wizardMySponsorshipsDisplayMessages = action.wizardMySponsorshipsDisplayMessages;
			state.wizardMyRecurringDisplayMessages = action.wizardMyRecurringDisplayMessages;
			state.wizardOrganizationContactTypes = action.wizardOrganizationContactTypes;
			state.wizardOrganizationTypes = action.wizardOrganizationTypes;
			state.wizardOtherAddressesDisplayMessages = action.wizardOtherAddressesDisplayMessages;
			state.wizardProductDownloadDisplayMessages = action.wizardProductDownloadDisplayMessages;
			state.wizardSavedPaymentsDisplayMessages = action.wizardSavedPaymentsDisplayMessages;
			state.wizardShoppingCartDisplayMessages = action.wizardShoppingCartDisplayMessages;
			state.wizardSmartyStreetsApiKey = action.wizardSmartyStreetsApiKey;
			state.wizardSponsorshipDefaults = action.wizardSponsorshipDefaults;
			state.wizardYearEndGivingStatementDisplayMessages = action.wizardYearEndGivingStatementDisplayMessages;
			return true; // Don't emit change

		case AccountConstants.SET_AUTO_ADD_STATE_AND_POSTAL_CODES:
			state.isAutoAddStateAndPostalCodes = action.isAutoAddStateAndPostalCodes;

			AccountStore.emitSpecificEvent(AccountConstants.SET_AUTO_ADD_STATE_AND_POSTAL_CODES);
			break;


		case AccountConstants.SET_SELECTED_COUNTRY:
			if (action.formParentId) {
				state.selectedCountryByForm[action.formParentId] = action.selectedCountry;
			} else {
				LoggerInstance.debug("Cannnot set selected country, action.formParentId was not provided.");
			}

			AccountStore.emitSpecificEvent(AccountConstants.SET_SELECTED_COUNTRY);
			break;

		case AccountConstants.SET_SELECTED_EMAIL_TYPE:
			if (action.formParentId) {
				state.selectedEmailTypeByForm[action.formParentId] = action.selectedEmailType;
			} else {
				LoggerInstance.debug("Cannot set selected email type, action.formParentId was not provided.");
			}

			AccountStore.emitSpecificEvent(AccountConstants.SET_SELECTED_EMAIL_TYPE);
			break;

		case AccountConstants.SET_SELECTED_ORGANIZATION_TYPE:
			if (action.formParentId) {
				state.selectedOrganizationTypeForm[action.formParentId] = action.selectedOrganizationType;
			}
			else {
				LoggerInstance.debug("Cannot set selected organization type, action.formParentId was not provided.");
			}
			break;

		case AccountConstants.SET_SELECTED_PHONE_TYPE:
			if (action.formParentId) {
				state.selectedPhoneTypeByForm[action.formParentId] = action.selectedPhoneType;
			} else {
				LoggerInstance.debug("Cannot set selected phone type, action.formParentId was not provided.");
			}

			AccountStore.emitSpecificEvent(AccountConstants.SET_SELECTED_PHONE_TYPE);
			break;

		case AccountConstants.SET_SELECTED_STATE:
			if (action.formParentId) {
				state.selectedStateByForm[action.formParentId] = action.selectedState;
			} else {
				LoggerInstance.debug("Cannot set selected state, action.formParentId was not provided.");
			}

			AccountStore.emitSpecificEvent(AccountConstants.SET_SELECTED_STATE);
			break;

		case AccountConstants.SET_SELECTED_TITLE:
			if (action.formParentId) {
				state.selectedTitleByForm[action.formParentId] = action.selectedTitle;
			}
			else {
				LoggerInstance.debug("Cannot set selected title, action.formParentId was not provided.");
			}
			break;

		case Constants.TOGGLE_CREATE_ACCOUNT_FORM_INPUTS:
			if (action.formParentId) {
				state.formIsInputDisabledByForm[action.formParentId] = action.disabled;
			} else {
				LoggerInstance.debug("Cannnot toggle disable/enable of form inputs, action.formParentId was not provided.");
			}
			break;

		default:
			// no op
			LoggerInstance.debug(`Undefined action triggered in account store. ${action.actionType}`);
			return true;
	};

	AccountStore.emitChange();
	return true;
});

module.exports = AccountStore;



// WEBPACK FOOTER //
// ./Javascript/accountComponents/AccountStore.jsx